import React from 'react';
import Card from '../ui/Card';
import { Search, Filter } from 'lucide-react';

interface ProjectFiltersProps {
    searchQuery: string;
    setSearchQuery: (q: string) => void;
    statusFilter: string;
    setStatusFilter: (s: string) => void;
    stageFilter: string;
    setStageFilter: (s: string) => void;
}

export const ProjectFilters: React.FC<ProjectFiltersProps> = ({
    searchQuery, setSearchQuery, statusFilter, setStatusFilter, stageFilter, setStageFilter
}) => {
    return (
        <Card className="p-4">
            <div className="flex flex-wrap gap-4 items-center">
                <div className="flex-1 min-w-[200px]">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary" size={18} />
                        <input
                            type="text"
                            placeholder="Search projects, customers..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 border border-border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                        />
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <Filter size={16} className="text-text-secondary" />
                    <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        className="px-3 py-2 border border-border rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                        <option value="all">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="archived">Archived</option>
                    </select>
                    <select
                        value={stageFilter}
                        onChange={(e) => setStageFilter(e.target.value)}
                        className="px-3 py-2 border border-border rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                        <option value="all">All Stages</option>
                        <option value="concept">Concept</option>
                        <option value="design">Design</option>
                        <option value="prototype">Prototype</option>
                        <option value="production">Production</option>
                        <option value="maintenance">Maintenance</option>
                    </select>
                </div>
            </div>
        </Card>
    );
};
